'use client'

import useSWR from 'swr'
import Marquee from 'react-fast-marquee'
import { useTranslations } from 'next-intl'
import { useParams } from 'next/navigation'

import OurClientCard from './OurClientCard'

import { ApiRoutes } from '@/api/routes'
import { fetcher } from '@/api/functions'

import type { IClientsData, IFetchedDataRoot } from '@/types'

const OurClients = () => {
  const t = useTranslations('OurClientsSection')
  const params = useParams()

  const { data: clients } = useSWR<IFetchedDataRoot<IClientsData>>(
    ApiRoutes.company.clients + `?lang=${params.locale}`,
    fetcher
  )

  return (
    <section className="pt-[30px] md:py-12">
      <h2 className="mb-5 text-center md:mb-10">{t('title')}</h2>
      <Marquee
        gradient
        gradientColor="#f3f2ef"
        gradientWidth={50}
        autoFill
        className="mb-2 md:mb-6"
      >
        {clients?.results?.slice(0, 6).map((client, i) => (
          <OurClientCard {...client} key={client.name + i} />
        ))}
      </Marquee>

      <Marquee gradient gradientColor="#f3f2ef" gradientWidth={50} direction="right" autoFill>
        {clients?.results?.slice(6).map((client, i) => (
          <OurClientCard {...client} key={client.name + i} />
        ))}
      </Marquee>
    </section>
  )
}

export default OurClients
